import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=3b122cac&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"
import style0 from "./coupon.vue?vue&type=style&index=0&id=3b122cac&prod&lang=scss&scoped=true"
import style1 from "./coupon.vue?vue&type=style&index=1&id=3b122cac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b122cac",
  null
  
)

export default component.exports